<template>
  <div class="collection-slider-wrapper">
    <div class="featured-products__slider">
      <collection-slider :data="data" v-on:sendToModal="openSliderModal">
      </collection-slider>
    </div>
    <modal class="quickview-modal" ref="sliderQuickview" :useTransition="false">
      <template slot="content">
        <product-top class="pdp-top--quickview" :data="sliderQuickviewData" :isQuickview="true"></product-top>
      </template>
    </modal>
  </div>
</template>

<script>
  import CollectionSlider from 'scripts/components/collection/CollectionSlider.vue';
  import Modal from 'scripts/components/basic/Modal.vue';
  import ProductTop from 'scripts/components/product/ProductTop.vue';

  export default {
    name: 'CollectionSliderWrapper',
    components: {
      CollectionSlider,
      Modal,
      ProductTop
    },
    props: {
      data: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        sliderQuickviewData: ''
      }
    },
    methods: {
      openSliderModal(data) {
        this.sliderQuickviewData = data;
        this.$refs.sliderQuickview.open();
      }
    },
  }
</script>

<style scoped lang="scss">
 .collection-slider-wrapper {  }
</style>